import _styled, { default as _styled2, default as _styled3 } from "styled-components";
import { Icon } from "~/features/ui/icon";
import Checkmark from "~/public/icons/checkmark.svg";
type Props = {
  message?: string;
  link?: React.ReactNode;
};
export function SuccessMessage(props: Props) {
  const {
    message = "Success!",
    link
  } = props;
  return <_StyledDiv>
      <_StyledDiv2>
        <_StyledDiv3>
          <Icon icon={Checkmark} size="16" />
        </_StyledDiv3>
        <p>{message}</p>
      </_StyledDiv2>
      {link && <div>{link}</div>}
    </_StyledDiv>;
}
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-sf-gfq5st-0"
})({
  "marginLeft": "auto",
  "marginRight": "auto",
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "rowGap": "2.4rem"
});
var _StyledDiv2 = _styled2("div").withConfig({
  componentId: "sc-sf-gfq5st-1"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "2.4rem",
  "textAlign": "center",
  "@media (min-width: 1024px)": {
    "flexDirection": "row",
    "padding": "0"
  }
});
var _StyledDiv3 = /*#__PURE__*/_styled3("div").withConfig({
  displayName: "success-message___StyledDiv3",
  componentId: "sc-s3spym-0"
})({
  "display": "flex",
  "height": "3.2rem",
  "width": "3.2rem",
  "alignItems": "center",
  "justifyContent": "center",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
});